import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ISidebar } from '../../interfaces/sidebar';
import { StateSidebarService } from '../../services/state-sidebar.service';
import { Subscription } from 'rxjs';
import { ESidebarState } from '../../enumerables/sidebarState';
import { ESidebarPosition } from '../../enumerables/sidebarPosition';
import { ResizedEvent } from 'angular-resize-event';

@Component({
  selector: 'app-default-sidebar',
  templateUrl: './default-sidebar.component.html',
  styleUrls: ['./default-sidebar.component.scss'],
})
export class DefaultSidebarComponent implements OnInit, OnDestroy, ISidebar {
  public state: ESidebarState;
  public position: ESidebarPosition;
  public stateSubscription: Subscription;
  public positionSubscription: Subscription;
  public toggleSubscription: Subscription;
  public isToggled: boolean;
  private innerWidth: number;

  private hoverTimeout: any;
  private hoverDelay = 200;
  private isHovering = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  constructor(public sidebarService: StateSidebarService) {
    this.isToggled = false;
  }

  public ngOnInit(): void {
    this.innerWidth = window.innerWidth;

    this.stateSubscription = this.sidebarService.stateSource.subscribe((state: ESidebarState) => {
      this.state = state;
    });

    this.positionSubscription = this.sidebarService.positionSource.subscribe((position: ESidebarPosition) => {
      this.position = position;
    });

    this.toggleSubscription = this.sidebarService.toggleSource.subscribe((toggled: boolean) => {
      this.toggleState(toggled);
    });
  }

  public ngOnDestroy(): void {
    this.stateSubscription.unsubscribe();
    this.positionSubscription.unsubscribe();
    this.toggleSubscription.unsubscribe();
  }

  public setOnHover(hover: boolean): void {
    clearTimeout(this.hoverTimeout);

    if (hover) {
      this.isHovering = true;
      this.sidebarService.setState(ESidebarState.open);
      this.sidebarService.setPosition(this.innerWidth < 992 ? ESidebarPosition.float : ESidebarPosition.fixed);
    } else {
      this.isHovering = false;

      this.hoverTimeout = setTimeout(() => {
        if (!this.isHovering) {
          this.sidebarService.setState(ESidebarState.closed);
          this.sidebarService.setPosition(this.innerWidth < 992 ? ESidebarPosition.float : ESidebarPosition.fixed);
        }
      }, this.hoverDelay);
    }
  }

  public setState(state: ESidebarState): void {
    this.sidebarService.setState(state);
  }

  public setPosition(position: ESidebarPosition): void {
    this.sidebarService.setPosition(position);
  }

  public onResized(event: ResizedEvent): void {
    this.sidebarService.setSize(event);
  }

  public toggleState(state: boolean): void {
    this.isToggled = state;
    this.sidebarService.setState(state ? ESidebarState.closed : ESidebarState.open);
    this.sidebarService.setPosition(this.innerWidth < 992 ? ESidebarPosition.float : ESidebarPosition.fixed);
  }
}
